import IconPicker from "./IconPicker";
import ListFieldTitle from "./ListFieldTitle";

function ListIconField({ field, value, onChange }) {
  return (
    <div>
      <ListFieldTitle field={field} />
      <IconPicker
        value={value}
        onChange={(next) => onChange(field.name, next)}
      />
    </div>
  );
}

export default ListIconField;
